const m = {
  sm: 480,
  md: 768,
  lg: 1024
};
export {
  m as BREAKPOINTS
};
